"use client";

import * as Api from "@api";
import React, { useMemo } from "react";
import { ProductSliderVariant } from "./Definitions";
import { ProductCard } from "./ProductCard";
import SnapSlider from "@/components/SnapSlider/SnapSlider";

interface ProductSliderProps {
  products: Api.ProductFull[];
  selectedCategoryId?: string;
  variant?: ProductSliderVariant;
}

export const ProductSlider = ({
  products,
  selectedCategoryId,
  variant,
}: ProductSliderProps): React.FunctionComponentElement<ProductSliderProps> => {
  // Sort by homePageOrder, filter to the selected category.
  const sortedProducts = useMemo(() => {
    return [...products]
      .sort((a, b) => (a.homePageOrder ?? 0) - (b.homePageOrder ?? 0))
      .filter((p) => p.category?.id === selectedCategoryId);
  }, [products, selectedCategoryId]);

  return (
    <div>
      {/* Was a Swiper free-mode row (FreeMode/Mousewheel/Scrollbar, navigation:false); now a
          native scroll row with no Swiper JS. Reproduces the live Swiper exactly:
          - slidesPerView 1.5 / 2.5 / 3 with spaceBetween 10 / 24 / 24 (breakpoints 550 / 768).
            Cell width = (100% - gap*(n-1)) / n, where 100% is the container's content width,
            so n cards fill the container just like Swiper's slidesPerView.
          - snap="none": the live slider was FreeMode — it scrolls freely, no snapping.
          - fullBleed: the live overflow-visible Swiper let cards bleed to the screen edges; the
            track breaks out of the container and re-insets content + snap origin to it.
          - scrollbar: the live draggable 2px progress bar (Swiper Scrollbar), no arrows. */}
      <SnapSlider
        scrollbar
        snap="none"
        fullBleed
        trackClassName="gap-[10px] min-[550px]:gap-6"
        itemClassName="w-[calc((100%_-_5px)_/_1.5)] min-[550px]:w-[calc((100%_-_36px)_/_2.5)] min-[768px]:w-[calc((100%_-_48px)_/_3)]"
      >
        {sortedProducts.map((product) => (
          <ProductCard key={product.id} product={product} transparent />
        ))}
      </SnapSlider>
    </div>
  );
};
